import { parseEntities, parseEntity } from '@/shared/converters/commonConverters';
import { parseMoment } from '@/shared/converters/dateConverters';
import User from '@/shared/models/User';
import QualityControl from '../models/QualityControl';

const SCHEMA = {
  id: 'id',
  status: 'status',
  comment: 'comment',
  dossierStatus: 'dossierQualityControlStatus',
  isMandatory: 'isMandatory',
  modifiedOn: (data: any) => parseMoment(data.modifiedOn),
  modifiedBy: (data: any) => User.withFullNameAndAvatar(data.modifiedByName, data.modifiedByAvatar),
};

export function parseQualityControl(data: any): QualityControl | null {
  return parseEntity(data, SCHEMA, QualityControl);
}

export function parseQualityControls(data: any): Array<QualityControl> {
  return parseEntities(data, SCHEMA, QualityControl);
}

export function formatQualityControl(qualityControl: QualityControl): any {
  return {
    status: qualityControl.status,
    comment: qualityControl.comment,
    isMandatory: qualityControl.isMandatory,
  };
}